<ion-button
  id="getm-button"
  #getmButtonRef
  mode="ios"
  [disabled]="disabled"
  [expand]="expand"
  [shape]="shape"
  [size]="size"
  [type]="type"
  [ngClass]="'getm-button-' + color"
  (click)="onButtonClick()"
  (ionBlur)="onButtonBlur($event)"
  (ionFocus)="onButtonFocus($event)"
>
  <ng-container *ngIf="!spinner; else spinnerTemplate">
    <ng-container *ngIf="icon">
      <ion-icon [name]="icon" [slot]="iconSlot"></ion-icon>
    </ng-container>

    <ng-container *ngIf="text">
      <ion-label>{{ text }}</ion-label>
    </ng-container>
  </ng-container>

  <ng-template #spinnerTemplate>
    <section class="spinner-container" [@buttonSpinner]="animationCounter">
      <ng-container *ngFor="let color of [1, 2, 3, 4]">
        <ion-badge mode="ios" class="punto-animado"> </ion-badge>
      </ng-container>
    </section>
  </ng-template>
</ion-button>
